import Marquee from "react-fast-marquee";

const words = ["WINGS", "TENDERS", "FRIES", "SAUCES", "ELOTE BLAST", "SALSA MACHA"];

export const MarqueeStrip = () => (
  <div className="relative border-y border-neon-green/25 bg-black py-6 sm:py-8">
    <Marquee speed={40} gradient={false} autoFill>
      {words.map((w, i) => (
        <span
          key={i}
          className="font-heading text-6xl sm:text-8xl lg:text-9xl mx-6 select-none text-stroke-green uppercase tracking-tight"
        >
          {w}
          <span className="text-neon-yellow mx-6">/</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeStrip;
